import {
  Box,
  Divider,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';

type Props = {
  settingDefs: any[];
  maxHeight?: number;
};

const SettingDefsView = ({ settingDefs = [] }: Props) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%', overflow: 'hidden' }}>
      <Box sx={{ mb: 1.5 }}>
        <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
          Settings
        </Typography>
      </Box>

      <Box sx={{ flex: 1, overflow: 'auto', pr: 0.5 }}>
        {settingDefs
          .filter((section) => !section.system)
          .map((section, idx) => (
            <Box
              key={idx}
              sx={{
                mb: 2,
                border: 1,
                borderColor: 'divider',
                borderRadius: '12px',
                overflow: 'hidden',
                bgcolor: 'background.paper',
              }}
            >
              <Box sx={{ px: 2, py: 1, borderBottom: 1, borderColor: 'divider', bgcolor: 'rgba(0,0,0,0.02)' }}>
                <Typography variant="body2" sx={{ fontWeight: 700 }}>
                  {section.sectionName}
                </Typography>
              </Box>

              <Box sx={{ p: 1 }}>
                <TableContainer>
                  <Table size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell
                          sx={{ borderRight: '1px solid', borderColor: 'divider', width: '25%', fontWeight: 700 }}
                        >
                          Name
                        </TableCell>
                        <TableCell
                          sx={{ borderRight: '1px solid', borderColor: 'divider', width: '25%', fontWeight: 700 }}
                        >
                          Label
                        </TableCell>
                        <TableCell
                          sx={{ borderRight: '1px solid', borderColor: 'divider', width: '25%', fontWeight: 700 }}
                        >
                          Type
                        </TableCell>
                        <TableCell sx={{ fontWeight: 700 }}>Required</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {(section.items || []).map((item: any, sIdx: number) => (
                        <TableRow key={sIdx} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                          <TableCell>{item.name}</TableCell>
                          <TableCell>{item.label}</TableCell>
                          <TableCell>{item.type}</TableCell>
                          <TableCell>{item.required ? 'Yes' : 'No'}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            </Box>
          ))}
      </Box>
    </Box>
  );
};

export default SettingDefsView;
